import React, { useMemo, useState } from "react";
import style from "./index.module.scss";
import QuestionnaireTopicsButtons from "./components/QuestionnaireTopicsButtons";
import QuestionnaireBar from "./components/QuestionnaireBar";
import { Button } from "antd";
import { AiOutlineLeftCircle, AiOutlineRightCircle } from "react-icons/ai";
import PageRadio from "./components/PageRadio";
import PageCheckBox from "./components/PageCheckBox";
import DetailLayout from "pages/CourseDetail/components/DetailLayout";
import PageSubjective from "./components/PageSubjective";
import { BaseQuestionType, PaperProps } from "../../../service";

interface ExerProps {
    data?: PaperProps;
    oneChange: (questionId: string, value: string) => void;
    moreChange: (questionId: string, value: any) => void;
    oneSave: (questionId: string, value: string) => void;
    moreSave: (questionId: string, value: any) => void;
    headerDom: React.ReactNode; //头部组件
}

export default function QuestionnairePC({
    data,
    oneChange,
    moreChange,
    oneSave,
    moreSave,
    headerDom
}: ExerProps) {
    const [checked, setChecked] = useState(1); //当前选中

    const currentData = useMemo(
        () => data?.topics.find((item, index) => index + 1 === checked),
        [data, checked]
    );

    function pageOneChange(questionId: string, value: string) {
        oneChange(questionId, value);
    }

    function pageMoreChange(questionId: string, value: any) {
        moreChange(questionId, value);
    }

    function pageOneSave(questionId: string, value: string) {
        oneSave(questionId, value);
    }

    function pageMoreSave(questionId: string, value: any) {
        moreSave(questionId, value);
    }

    return (
        <DetailLayout breadcrumb="提交问卷">
            {headerDom}
            <QuestionnaireTopicsButtons
                topicCount={data?.topicCount || "0"}
                totalScore={data?.totalScore || "0"}
            />

            <div className={style.main}>
                <div className={style.left}>
                    {data && (
                        <QuestionnaireBar
                            checked={checked}
                            data={data.topics}
                            onChange={(val: number) => setChecked(val)}
                        />
                    )}
                </div>

                <div className={style.right}>
                    {currentData &&
                        currentData.queTypeId ===
                            BaseQuestionType.SingleChoice &&
                        checked === currentData.index && (
                            <PageRadio
                                data={currentData}
                                oneSave={pageOneSave}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId ===
                            BaseQuestionType.MultipleChoice &&
                        checked === currentData.index && (
                            <PageCheckBox
                                data={currentData}
                                moreSave={pageMoreSave}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId === BaseQuestionType.Subjective &&
                        checked === currentData.index && (
                            <PageSubjective
                                data={currentData}
                                oneSave={pageOneSave}
                                oneChange={pageOneChange}
                            />
                        )}

                    <div className={style.footer}>
                        {currentData && currentData.index !== 1 && (
                            <Button
                                className={style.prev}
                                onClick={() =>
                                    setChecked(currentData.index - 1 || 1)
                                }>
                                <AiOutlineLeftCircle />
                                上一题
                            </Button>
                        )}
                        {currentData &&
                            data &&
                            currentData.index !== data.topics.length && (
                                <Button
                                    className={style.next}
                                    onClick={() =>
                                        setChecked(currentData.index + 1 || 1)
                                    }>
                                    下一题
                                    <AiOutlineRightCircle />
                                </Button>
                            )}
                        {currentData &&
                            data &&
                            currentData.index === data.topics.length && (
                                <div className={style.lastDiv}>
                                    已是最后一题了
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </DetailLayout>
    );
}
